import { render, staticRenderFns } from "./NozamaTemplates.vue?vue&type=template&id=401248c9"
import script from "./NozamaTemplates.vue?vue&type=script&lang=js"
export * from "./NozamaTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports